export default "__VITE_ASSET__JszRQ3wp__"